
import React, { useEffect, useCallback, useState } from "react";
import Select from "react-select";
import {
    simulationMois, verifEntete, saveFile
} from "../../Redux/simulationReduce";
import { useDispatch } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { fetchAnnee } from "../../Redux/anneeReduce";
import Configuration from "../../configuration";
import { verif } from "./verif_Simulation";
import { getGrossisteSite } from "../../Redux/grossisteReduce";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function extraction_Simulation({ client }) {

    const navigate = useHistory();
    const dispatch = useDispatch();
    const location = useParams();

    if (location.id != undefined) {

    }

    const [variable, setVariable] = React.useState("");
    const [alert, setAlert] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(0);
    const [uploadFile, setUploadFile] = React.useState()
    const [fileName, setFileName] = useState(null);
    const [month, setmonth] = React.useState();
    const [year, setyear] = React.useState();
    const [readonly, setreadonly] = React.useState(0);


    const notify = (type, msg) => {
        if (type === 1)
            toast.success(<strong>{msg}</strong>);
        else
            toast.error(<strong>{msg}</strong>);
    }

    //mois
    const [optionsmois, setmoisOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un mois",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [moisSelect, setmoisSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un mois",
        style: "placeholder",
    });

    //annee
    const [anneeSelect, setanneeSelect] = React.useState({
        value: 0,
        label: "veuillez choisir une année",
        style: "placeholder",
    });
    const [optionsannee, setanneeOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir une année",
            isDisabled: true,
            style: "placeholder",
        },
    ]);


    const fileHandler = (e) => {
        let fileObj = e.target.files[0];
        if (fileObj) {
            setUploadFile(fileObj);
            var str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
            setFileName(str);
        }
    };


    const verifmois = useCallback(
        async (b) => {

            var entities = [
                { id: 1, nom: "Janvier" }, { id: 2, nom: "Février" }, { id: 3, nom: "Mars" },
                { id: 4, nom: "Avril" }, { id: 5, nom: "Mai" }, { id: 6, nom: "Juin" },
                { id: 7, nom: "Juillet" }, { id: 8, nom: "Aout" }, { id: 9, nom: "septembre" },
                { id: 10, nom: "Octobre" }, { id: 11, nom: "Novembre" }, { id: 12, nom: "Décembre" },
            ]
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un mois", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.nom });
                if (a.id === b || a.nom === b) {
                    setmoisSelect({ value: a.id, label: a.nom });
                    setmonth(a.id);
                }
            });
            setmoisOptions(arOption);
        },
        [dispatch]
    );


    const verifannee = useCallback(
        async (b) => {
            var Simulation = await dispatch(fetchAnnee());
            var entities = Simulation.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir une année", style: "placeholder" });
            const currentYear = new Date().getFullYear();
            entities.forEach((a, index) => {
                arOption.push({ value: a.id, label: a.annee });

                //if (index === entities.length - 1) {
                if (currentYear === parseInt(a.annee)) {
                    setanneeSelect({ value: a.id, label: a.annee });
                    setyear(a.annee);
                }
                //}
            });
            setanneeOptions(arOption);
        },
        [dispatch]
    );

    const showTable = useCallback(async (mois, annee, fileName, uploadFile) => {
        try {
            if (mois !== null && annee != null) {
                setreadonly(1)
                if (location.id == undefined) {
                    const verificationResult = await dispatch(
                        verifEntete({
                            date: annee,
                            month: mois,
                            fileName: fileName,
                            id_site: client == "/medis" ? 2 : 3
                        })
                    );

                    if (verificationResult.payload == false) {
                        setIsLoading(1)
                        const response = await dispatch(
                            simulationMois({
                                date: annee,
                                month: mois,
                                id_site: client == "/medis" ? 2 : 3
                            })
                        );
                        if (response.payload.file != undefined) {
                            const filename = response.payload.file;
                            window.open(`${Configuration.BACK_BASEURL}simulation/${filename}`, "_blank");
                            setIsLoading(0)
                            setTimeout(() => {
                                window.location.reload()
                            }, 1000);
                        } else {
                            setreadonly(0)
                            setIsLoading(0)
                            notify(2, "Aucune donnée trouvée pour cette période");
                        }
                    } else {
                        notify(2, "Les données pour ce mois ont déjà été générées.");
                        setreadonly(0)
                        setIsLoading(0)

                    }
                } else {
                    console.log(fileName)
                    if (fileName != null) {
                        const verificationResult = await dispatch(
                            verifEntete({
                                date: annee,
                                month: mois,
                                fileName: fileName,
                                id_site: client == "/medis" ? 2 : 3
                            })
                        );
                        if (verificationResult.payload === true) {
                            setIsLoading(1)
                            const arrayBody = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
        try {
            const buffer = e.target.result;

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.worksheets[0]; // First sheet

            const rows = [];

            worksheet.eachRow({ includeEmpty: true }, (row) => {
                // ExcelJS row.values starts at index 1
                const rowData = row.values.slice(1);
                rows.push(rowData);
            });

            resolve(verif(rows, month, anneeSelect.label));
        } catch (err) {
            console.error("Error reading Excel file:", err);
            reject(err);
        }
    };

    reader.onerror = (err) => reject(err);

    reader.readAsArrayBuffer(uploadFile);
});


                            if (arrayBody.test === false) {
                                notify(2, "Vérifier les champs de votre fichier excel");
                                window.location.reload();
                            } else {

                                checkProd(arrayBody.array, mois, annee, uploadFile);
                            }

                        } else {
                            setreadonly(0)
                            setIsLoading(0)
                            notify(2, "Générez les données avant d'apporter des modifications.");

                        }
                    } else {
                        setreadonly(0)
                        setIsLoading(0)
                        notify(2, "Aucun fichier sélectionné. Veuillez en choisir un.");
                    }
                }
            } else {
                setreadonly(0)
                setIsLoading(0)
                notify(2, "Aucune donnée trouvée pour cette période");
            }
        } catch (error) {
            setreadonly(0)
            setIsLoading(0)
            notify(2, "Aucune donnée trouvée pour cette période");
            console.log("An error occurred:", error);
        }
    }, [dispatch]);


    const checkProd = useCallback(
        async (table, mois, annee, uploadFile) => {
            let arrayBody = [];

            const grossistesite = await dispatch(
                getGrossisteSite({ id_site: client === Configuration.industrie2 ? 2 : 3 })
            );
            for (let i = 0; i < table.length; i++) {
                const currentClient = table[i]?.code_grossiste;
                const idGrossiste = Object.keys(grossistesite.payload).find(
                    key => grossistesite.payload[key] === currentClient
                );
                arrayBody.push({
                    code: table[i]?.code,
                    cmdVf: table[i]?.cmdVf,
                    grossiste: table[i]?.grossiste,
                    code_grossiste: currentClient,
                    id_grossiste: parseInt(idGrossiste) || null
                });

            }
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("name", uploadFile.name);

            dispatch(saveFile(dataArray)).then(async (e) => {
                //var filename2 = e.payload.filename;

                const response = await dispatch(
                    simulationMois({
                        id_entete: location.id,
                        date: annee,
                        month: mois,
                        filename: e.payload.filename,
                        entities: arrayBody,
                        id_site: client == "/medis" ? 2 : 3
                    })
                );

                const filename = response.payload.file;
                if (filename) {
                    window.open(`${Configuration.BACK_BASEURL}simulation/${filename}`, "_blank");
                    notify(1, "Extraction avec succès");

                    setIsLoading(0)
                    setTimeout(() => {
                        window.location.reload()
                    }, 1000);
                }else{
                     notify(1, "Vérifier vos données");
                    setIsLoading(0)
                }
            });

        },
        [dispatch]
    );


    function listepp() {
        navigate.push(client + "/listSimulation");
    }


    useEffect(() => {
        switch (month) {
            case 1:
                setVariable("JANVIER");
                break;
            case 2:
                setVariable("FEVRIER");
                break;
            case 3:
                setVariable("MARS");
                break;
            case 4:
                setVariable("AVRIL");
                break;
            case 5:
                setVariable("MAI");
                break;
            case 6:
                setVariable("JUIN");
                break;
            case 7:
                setVariable("JUILLET");
                break;
            case 8:
                setVariable("AOUT");
                break;
            case 9:
                setVariable("SEPTEMBRE");
                break;
            case 10:
                setVariable("OCTOBRE");
                break;
            case 11:
                setVariable("NOUVEMBRE");
                break;
            case 12:
                setVariable("DECEMBRE");
                break;
            default:
                break;
        }

        //ProdParent(0)
        verifmois(location.id != undefined ? localStorage.getItem("mois") : 0)
        verifannee(location.id != undefined ? localStorage.getItem("annee") : 0)
    }, []);


    return (

        <>
            <Container fluid className="responsive-BL table-dynamique releve-class">
                <ToastContainer />
                {alert}
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-list"></i>
                            </span>
                            Retour à la liste
                        </Button>
                    </Col>


                </Row>

                <Row>
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover">
                            <Card.Header>
                                <Card.Title as="h3" style={{ textAlign: "center", color: "#0077af" }}><strong>{variable}</strong> </Card.Title>
                                <Row>
                                    <Col md="10">
                                        <Card.Title as="h4">Simulation commande</Card.Title>
                                    </Col>

                                </Row>

                            </Card.Header>
                            <Card.Body>



                                <Row>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Mois</label>
                                            <Select
                                                placeholder="Mois "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                isDisabled={readonly === 1 || location.id != undefined}
                                                value={moisSelect}
                                                onChange={(value) => {
                                                    setmoisSelect(value);
                                                    setmonth(value.value);
                                                }}
                                                options={optionsmois}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Année</label>
                                            <Select
                                                placeholder="Année "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                value={anneeSelect}
                                                isDisabled={readonly === 1 || location.id != undefined}
                                                onChange={(value) => {
                                                    setanneeSelect(value);
                                                    setyear(value.value);
                                                }}
                                                options={optionsannee}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br></br><br></br>



                                <br></br>
                                <br></br>
                                <div className="text-center" style={{ display: month != 0 ? 'block' : 'none' }}>
                                    {location.id != undefined ?
                                        <Form.Group  >
                                            <Form.Control
                                                id="test"
                                                name="file"
                                                type="file" isDisabled={readonly === 1}
                                                accept=".xls, .xlsx"
                                                onChange={(e) => {
                                                    fileHandler(e);
                                                }}
                                            ></Form.Control>
                                        </Form.Group>
                                        : null}
                                    <Button
                                        className="btn-wd btn-outline mr-1 float-right simulation"
                                        id="blExt"
                                        type="button"
                                        variant="info"
                                        style={{ display: readonly === 0 ? 'block' : 'none' }}
                                        onClick={(v) => {
                                            showTable(month, year, fileName, uploadFile);

                                        }}
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-cogs"></i>
                                        </span>
                                        Simulation commmande
                                    </Button>
                                </div>
                                <div className="loader-container" style={{ display: isLoading === 1 ? 'block' : 'none' }}>
                                    <div className="loader"></div>
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default extraction_Simulation;
